import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import isAccessTokenValid from '@app/helpers/isAccessTokenValid'
import isUserLoggedIn from '@app/helpers/isUserLoggedIn'
// @ts-ignore
import * as syncNotifications from '@app/actions/notifications/notificationsChannel'
import MyDevicesInfo from '@app/components/MyDevices/DeviceInfo/DeviceInfo'
import { withAccessDenied, withNotifications, withProgressAndErrorMessage } from '@app/hocs'
import { AppState } from '@app/@types/store'
import { AppDispatch } from '@app/store'

let enhance = MyDevicesInfo

const mapStateToProps = (state: AppState) => {
  const { devices } = state.myDevices.myDevices
  const { role } = state.users.currentUser.user
  const {
    currentDevice,
    fetchingDevicesFinished,
    reinterviewInProgress,
    interviewResult,
    deletingResult,
    deletingDeviceInProgress,
    fetchingDeviceStats,
    deviceInfoError,
  } = state.myDevices.myDevices
  const { status: guardPanelStatus } = state.guardPanel
  const { isMobile } = state.mobileDetector
  return {
    currentDevice,
    devices,
    fetchingDevicesFinished,
    reinterviewInProgress,
    interviewResult,
    deletingResult,
    deletingDeviceInProgress,
    guardPanelStatus,
    role,
    isMobile,
    fetchingDeviceStats,
    deviceInfoError,
    inProgress: state.apiRequest.inProgress,
    errorMessage: state.apiRequest.errorMessage,
    accessToken: state.secrets.accessToken && state.secrets.accessToken.token,
    accessDenied: !isAccessTokenValid(state.secrets.accessToken),
    userLoggedIn: (isUserLoggedIn(state.users.currentUser.user.preferredName)),
  }
}

const mapDispatchToProps = (dispatch: AppDispatch) => bindActionCreators({
  notifications: syncNotifications.sync,
}, dispatch)

enhance = withProgressAndErrorMessage(enhance)
enhance = withAccessDenied(enhance)
enhance = withNotifications(enhance)
// @ts-ignore
enhance = connect(mapStateToProps, mapDispatchToProps)(enhance)

const MyDevicesInfoEnhanced = enhance

export default MyDevicesInfoEnhanced
